'use strict';

export function trimString (value) {
    if (value === null || value === undefined) {
        return null;
    }

    var stringValue = String(value).trim();
    return stringValue || null;
}

export function toPositiveInt (value, fallback) {
    var parsed = parseInt(value, 10);
    if (isNaN(parsed) || parsed <= 0) {
        return fallback;
    }
    return parsed;
}

export function toNonNegativeInt (value, fallback) {
    var parsed = parseInt(value, 10);
    if (isNaN(parsed) || parsed < 0) {
        return fallback;
    }
    return parsed;
}

export function parseJson (value) {
    if (!value || typeof value !== 'string') {
        return null;
    }

    try {
        return JSON.parse(value);
    } catch (e) {
        return null;
    }
}

export function normalizeCurrencyCode (value) {
    var normalized = trimString(value);
    if (!normalized) {
        return 'EUR';
    }

    var upper = String(normalized).toUpperCase();
    if (/^[A-Z]{3}$/.test(upper)) {
        return upper;
    }

    var bySymbol = {
        '€': 'EUR',
        '$': 'USD',
        '£': 'GBP',
        '¥': 'JPY',
    };

    return bySymbol[normalized] || bySymbol[String(normalized).charAt(0)] || 'EUR';
}

export function parsePriceNumber (value) {
    if (typeof value === 'number' && isFinite(value)) {
        return value;
    }

    if (typeof value !== 'string') {
        return null;
    }

    var normalized = value
        .replace(',', '.')
        .replace(/[^0-9.-]/g, '');
    var parsed = parseFloat(normalized);

    return isNaN(parsed) ? null : parsed;
}

export function appendQueryParams (url, params) {
    var normalizedUrl = trimString(url);
    if (!normalizedUrl || !params || typeof params !== 'object') {
        return normalizedUrl;
    }

    var queryParts = [];
    var key;

    for (key in params) {
        if (!Object.prototype.hasOwnProperty.call(params, key)) {
            continue;
        }

        var value = params[key];
        if (value === null || value === undefined || value === '') {
            continue;
        }

        queryParts.push(
            encodeURIComponent(key) + '=' + encodeURIComponent(String(value))
        );
    }

    if (!queryParts.length) {
        return normalizedUrl;
    }

    return normalizedUrl +
        (normalizedUrl.indexOf('?') === -1 ? '?' : '&') +
        queryParts.join('&');
}
